import { types, actions } from './requests'
export const SAVESERVICE_TYPES = {
    ...types('SAVESERVICE'),
}
export const SAVESERVICE_ACTIONS = {
    ...actions('SAVESERVICE'),
}
